import { BasicResponseDTO } from './basicResponse.dto';

export enum AuditEventCategory {
  SYSTEM = 'system',
  USER = 'user',
}

export class AuditItem {
  user: string;
  time: string;
  event: string;
  affected?: string;
  category?: AuditEventCategory;
}

export class AuditItemResponseDTO extends BasicResponseDTO {
  data: AuditItem[];
}
